module.exports = __webpack_public_path__ + "static/media/206-gallery07.4319ffb1.jpg";